<template>
  <div>
    <form @submit.prevent="handleSubmit" v-if="!isFormSubmitted">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <input type="text" name="first_name" class="form-control" required placeholder="First name" v-model="first_name">
        </div>
        <div class="col-12 col-md-6 mb-3">
          <input type="text" name="last_name" class="form-control" required placeholder="Last name"  v-model="last_name">
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <input type="text" name="company" class="form-control" required placeholder="Company" v-model="company">
        </div>
        <div class="col-12 col-md-6 mb-3">
          <input type="text" name="title" class="form-control" required placeholder="Title" v-model="title">
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <input type="email" name="email" class="form-control" required placeholder="E-mail" v-model="email">
        </div>
        <div class="col-12 col-md-6 mb-3">
          <input type="tel" name="phone" class="form-control" placeholder="Phone (optional)" v-model="phone">
        </div>
      </div>
      <div class="mb-3">
        <textarea name="comment" class="form-control" placeholder="Please leave your message here (optional)" row="1" v-model="comment"></textarea>
      </div>
      <button class="btn btn-theme">Send</button>
      <span class="ml-2">
        By submitting the form, you accept <router-link :to="{name: 'privacy'}">Privacy Policy</router-link> of this website.
      </span>
    </form>
    <div v-else class="d-flex align-items-center">
      <Success class="mr-2" />
      <h4 class="mb-0">Thank you for reaching out! We will get back to you soon</h4>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Success from '../elements/Success'

export default {
  name: 'MainContact',
  data() {
    return {
      first_name: '',
      last_name: '',
      company: '',
      title: '',
      email: '',
      phone: '',
      comment: '',
      isFormSubmitted: false
    }
  },
  components: {
    Success
  },
  props: {
    subject: {
      type: String,
      default: 'Contact us'
    }
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&')
    },
    handleSubmit() {
      axios.post(
        window.location.href,
        this.encode({
          'form-name': 'contact',
          subject: this.subject,
          first_name: this.first_name,
          last_name: this.last_name,
          thisany: this.company,
          title: this.title,
          email: this.email,
          phone: this.phone,
          comment: this.comment
        }),
        { header: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      ).then(() => {
        this.isFormSubmitted = true
        this.first_name = ''
        this.last_name = ''
        this.company = ''
        this.title = ''
        this.email = ''
        this.phone = ''
        this.comment = ''
      }).catch(err => {
        alert('Something went wrong. Please try again', err)
      })
    }
  }
}
</script>
